module.exports = __webpack_public_path__ + "static/media/machine.16149ddc.jpg";